import * as Yup from 'yup';

import { VALIDATORS } from 'constants/index';
import { IS_VANITY_URL_AVAILABLE } from 'graphql/show';
import { chackAvailability } from 'graphql/utils';
import { uniqueEmailValidator } from 'utils/form';

const vanityUrlValidator = Yup.string()
  .matches(VALIDATORS.SLUG, { message: 'Please enter a valid handle.' })
  .required('Handle is required.')
  .min(1, 'Handle must be at least 1 character.')
  .test('UniqueVanityUrl', 'Another show with this handle already exists.', async function (
    vanityUrl: string,
  ) {
    if (!vanityUrl || !vanityUrl.length) {
      throw this.createError({ message: 'Handle must be at least 1 character' });
    }
    try {
      const { isVanityUrlAvailable } = await chackAvailability(IS_VANITY_URL_AVAILABLE, vanityUrl);
      return isVanityUrlAvailable;
    } catch (e) {
      return false;
    }
  });

export const signupValidationSchema = Yup.object().shape({
  vanityUrl: vanityUrlValidator,
  email: uniqueEmailValidator,
  password: Yup.string()
    .min(8, 'Password must contain at least 8 characters')
    .required('Password must contain at least 8 characters'),
});

export const signupContinueValidationSchema = Yup.object().shape({
  vanityUrl: vanityUrlValidator,
});
